import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Resources/Resource.tsx");
